import React from 'react'
import clsx from 'clsx'
import { ArrowDown2 } from 'iconsax-react'

import AddColor from '../../Controls/Add/AddColour/'
import Dropdown from '../../../../components/atoms/Dropdown'

import { useSettingsEdit } from '../../../../providers/SettingsEditProvider'

import useStyles from '../styles'

const OPTIONS = ['Open', 'Completed']

interface StatusEditProps {
  obj: any
  superType: string
  locked?: boolean
}

const StatusEdit: React.FC<StatusEditProps> = ({ obj, superType, locked }) => {
  const [color, setColor] = React.useState(obj.colour)
  const [name, setName] = React.useState(obj.name)
  const [base, setBase] = React.useState(obj.base_status)

  const classes = useStyles()

  const { setSave } = useSettingsEdit()

  React.useEffect(() => {
    if (color || name || base) {
      let existing = { ...obj }

      existing = {
        ...existing,
        colour: color,
        name: name,
        base_status: base
      }

      setSave(existing)
    }
    // adding obj here as a dependency will create infinite rerenders
    // eslint-disable-next-line
  }, [color, name, base, setSave])

  React.useEffect(() => {
    if (base) {
      setBase(base => {
        return base.charAt(0).toUpperCase() + base.slice(1)
      })
    }
  }, [base])

  return (
    <div className={classes.complexEdit}>
      <div style={{ cursor: 'pointer' }}>
        <AddColor prevColor={color} saveColor={setColor} />
      </div>

      {superType !== 'user' && (
        <div className={classes.complexEdit}>
          <Dropdown
            options={OPTIONS}
            selected={base ?? 'Open'}
            onSelect={val => setBase(val)}
            hideAdd
            hideClose
            stringOnly
            disabled={locked}
          >
            <div className={classes.editDropdown}>
              <span style={{ paddingRight: '1rem' }}>{base ?? 'Open'}</span>
              <ArrowDown2 className={classes.icon} />
            </div>
          </Dropdown>
        </div>
      )}

      <input
        value={name}
        onChange={e => setName(e.target.value)}
        className={clsx(classes.input, classes.shortInput)}
        maxLength={25}
        disabled={locked}
      />
    </div>
  )
}

export default StatusEdit
